import { fetchPageAssets } from '../../ducks/hostedAssets.duck';
import { createImageVariantConfig } from '../../util/sdkLoader';

export const ASSET_NAME = 'landing-page';
export const latestSectionId = 'latest-listings';

// Hakuparametrit uusimmille listauksille
export const getLatestListingParams = (config, { perPage = 8 } = {}) => {
  const {
    aspectWidth = 1,
    aspectHeight = 1,
    variantPrefix = 'listing-card',
  } = config.layout.listingImage;
  const aspectRatio = aspectHeight / aspectWidth;

  return {
    // UUSIMMAT ENSIN: Sharetriben Marketplace API:ssa `sort=createdAt` antaa laskevan järjestyksen.
    // Prefix '-' kääntää suunnan (eli -createdAt olisi vanhimmat ensin).
    sort: 'createdAt',
    page: 1,
    perPage, // Jos omassa templaten versiossa käytetään snake_casea, vaihda tähän 'per_page'.
    include: ['author', 'images'],
    'fields.listing': [
      'title',
      'price',
      'deleted',
      'state',
      'publicData.transactionProcessAlias',
    ],
    'fields.user': ['profile.displayName', 'profile.abbreviatedName'],
    'fields.image': [
      'variants.scaled-small',
      'variants.scaled-medium',
      `variants.${variantPrefix}`,
      `variants.${variantPrefix}-2x`,
    ],
    ...createImageVariantConfig(`${variantPrefix}`, 400, aspectRatio),
    ...createImageVariantConfig(`${variantPrefix}-2x`, 800, aspectRatio),
    'limit.images': 1,
  };
};


export const loadData = (params, search) => dispatch => {
  const pageAsset = { landingPage: `content/pages/${ASSET_NAME}.json` };
  return dispatch(fetchPageAssets(pageAsset, true));
};
